import { login as loginCache, logout as logoutCache } from '../utils/auth'
// vuex actions
export function updateDirection (store, new_from, new_to) {
  const { commit, state } = store
  var new_to_path = new_to.path
  var new_from_path = new_from.path || '/'

  if (new_from.path && state.route.pathLevel < 0) {
    // 确保直接刷新带路由的页面，第一次进入直接添加路径 eg.('/', '/finishinfo')
    commit('PUSH_PATH', {from: new_from_path, to: {path: new_to_path}})
    commit('UPDATE_DIRECTION', 'forward')
    return
  }
  // 确保 router 再次重复进入一个页面？
  if (new_from && new_to && new_from.path === new_to.path) return

  const {from, to} = state.route.pathStack[state.route.pathLevel]

  if (new_from_path === to.path && new_to_path !== from.path) {
    // 进入新的页面
    commit('PUSH_PATH', {from: {path: new_from_path}, to: {path: new_to_path}})
    commit('UPDATE_DIRECTION', 'forward')
  } else if (new_from_path === to.path && new_to_path === from.path) {
    // 返回旧的页面
    commit('POP_PATH')
    commit('UPDATE_DIRECTION', 'back')
  } else {
    // 跳转页面
    commit('PUSH_PATH', {from: {path: new_from_path}, to: {path: new_to_path}})
    commit('UPDATE_DIRECTION', 'forward')
  }
}

export function login ({commit}, token) {
  loginCache(token)
  commit('LOGIN')
}

export function logout ({commit}) {
  logoutCache()
  commit('LOGOUT')
}

export function updateWinHeight ({commit}, height) {
  commit('UPDATE_WIN_HEIGHT', height)
}

export function updateWinWidth ({commit}, width) {
  commit('UPDATE_WIN_WIDTH', width)
}
